// extracted by mini-css-extract-plugin
export default {"title":"title-EYmvI","radio":"radio-cEFiB","label":"label-Qb6OA","questionMarkIcon":"questionMarkIcon-qxjQI"};